import {theme} from "antd";

// Highlight for an active drag-and-drop target. Built from the success tokens so it reads in
// both themes (the old fixed #f6ffed / #b7eb8f pair left light text on pale green in dark mode).
const useDropTargetStyle = isActive => {
    const {token} = theme.useToken()

    return isActive ? {
        border: `1px solid ${token.colorSuccessBorder}`,
        backgroundColor: token.colorSuccessBg,
    } : {}
}

export default useDropTargetStyle
